import { useState } from "react";

import { Switch } from "@/components/ui/switch";

interface AiRule {
  id: string;
  title: string;
  description: string;
  defaultEnabled: boolean;
}

const AI_RULES: AiRule[] = [
  {
    id: "advies-tipsheets",
    title: "Adviseert op basis van tip sheets",
    description: "Ethische Etna baseert suggesties op de goedgekeurde tip sheets van de commissie.",
    defaultEnabled: true,
  },
  {
    id: "advies-eerdere-dossiers",
    title: "Adviseert op basis van eerder ingediende dossiers",
    description:
      "Ethische Etna vergelijkt met eerdere, afgeronde dossiers om patronen te herkennen.",
    defaultEnabled: true,
  },
  {
    id: "proactief-invullen",
    title: "Vult proactief velden in op basis van aangeleverde context",
    description:
      "Ethische Etna stelt automatisch invulling voor op basis van eerder aangeleverde informatie.",
    defaultEnabled: false,
  },
  {
    id: "context-verbeteren",
    title: "Verbetert aangeleverde context automatisch",
    description:
      "Ethische Etna herschrijft of verduidelijkt tekst die de onderzoeker heeft aangeleverd.",
    defaultEnabled: false,
  },
  {
    id: "conditional-revisions",
    title: "Maakt automatisch conditional revisions",
    description:
      "Ethische Etna stelt zelfstandig voorwaardelijke herzieningen op bij kleine issues.",
    defaultEnabled: false,
  },
  {
    id: "issue-detectie",
    title: "Detecteert issues tijdens pre-screening",
    description:
      "Ethische Etna markeert ontbrekende documenten, incomplete velden en guideline-afwijkingen.",
    defaultEnabled: true,
  },
  {
    id: "briefing-genereren",
    title: "Genereert reviewer-briefings",
    description:
      "Ethische Etna stelt een samenvatting op voor reviewers voorafgaand aan de bureauvergadering.",
    defaultEnabled: true,
  },
  {
    id: "vergelijkbare-dossiers",
    title: "Toont vergelijkbare dossiers bij review",
    description:
      "Ethische Etna signaleert gelijkaardige aanvragen uit het verleden aan de reviewer.",
    defaultEnabled: false,
  },
];

export function AiRegelsPage() {
  const [enabled, setEnabled] = useState<Record<string, boolean>>(() =>
    Object.fromEntries(AI_RULES.map((rule) => [rule.id, rule.defaultEnabled])),
  );

  const activeCount = Object.values(enabled).filter(Boolean).length;

  return (
    <section>
      <div className="page-head">
        <div>
          <h1>AI-regels</h1>
          <p>Bepaal welke AI-ondersteuning Ethische Etna mag bieden tijdens het proces</p>
        </div>
      </div>

      <div className="card ua-mt-space">
        <div className="card__head">
          <h2>Regels</h2>
          <span className="ua-muted-sm">
            {activeCount} van de {AI_RULES.length} actief
          </span>
        </div>
        <div className="card__body pt-3">
          <ul className="ua-col-sm-tight">
            {AI_RULES.map((rule) => (
              <li key={rule.id} className="control-item">
                <div>
                  <div className="ua-bold-sm">{rule.title}</div>
                  <div className="ua-muted-xs">{rule.description}</div>
                </div>
                <Switch
                  checked={enabled[rule.id]}
                  onCheckedChange={(checked) =>
                    setEnabled((prev) => ({ ...prev, [rule.id]: checked }))
                  }
                  aria-label={rule.title}
                  className="ml-auto"
                />
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
